import { Component, OnInit } from '@angular/core';
import { SystemService } from 'src/app/services/system.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { AgencyDto} from './agency.dto';
import { CaseService } from '../../services/case.service';


@Component({
  selector: 'app-agency',
  templateUrl: './agencies.component.html'
})
export class AgenciesComponent implements OnInit {

  isNewEntry = false;
  cols: any[];
  agencyList: AgencyDto[];
  myAgency: AgencyDto;
  userType = '';

  displayState: any = {
    workingDiv: false,
    agencyDiv: false,
    gridDiv: false,
    editAgencyDiv: false,
    saveDisabled: false
  };
  filterOptions: any = {
    filterText: '',
  }

  constructor(private systemService: SystemService, private messageService: MessageService,
              private confirmationService: ConfirmationService, private caseService: CaseService, private utilService: UtilitiesService) { }

  ngOnInit() {
    this.cols = [
      { field: 'id'},
      { field: 'name', header: 'Name'},
      { field: 'strAddr', header: 'Street Address'},
      { field: 'addrUnit', header: 'Unit#'},
      { field: 'city', header: 'City'},
      { field: 'state', header: 'State'},
      { field: 'zip', header: 'Zip Code'},
      { field: 'contact', header: 'Contact Name'},
      { field: 'phone', header: 'Phone#'},
      { field: 'altPhone', header: 'Alt Phone#'},
      { field: 'fax', header: 'Fax#'},
      { field: 'emailAddr', header: 'Email'},
    ];
   this.loadAgencyList();
  }

  loadAgencyList() {
    this.displayState.gridDiv = false;
    this.displayState.workingDiv = true;
    this.caseService.getAgencyList().subscribe (data => {
      //this.agencyList = [];
      this.agencyList = data;
      this.filterOptions.filterText = ''; // clear any filters...
      this.displayState.workingDiv = false;
      this.displayState.gridDiv = true;
    });
  }

  selectAgency(agency: AgencyDto) {
    this.displayState.workingDiv = true;
    this.caseService.getAgency(agency.id).subscribe(data => {
      this.myAgency = data;
      this.displayState.workingDiv = false;
      this.displayState.gridDiv = false;
      this.displayState.editAgencyDiv = true;
      this.utilService.doAudit(data, 'Agency data:');
    });
  }

  initAgency() {
    this.myAgency = {
      id: "",
      name: "",
      strAddr: "", 
      city: "",
      state: "",
      zip: "",
      contact: "",
      phone: "",
      altPhone: "",
      fax: "",
      email: "",
      addrUnit: ""
      }
  }
  newAgency() {
    this.initAgency();
    this.displayState.workingDiv = false;
    this.displayState.gridDiv = false;
    this.displayState.editAgencyDiv = true;
}

  deleteAgency(agency: AgencyDto) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.caseService.deleteAgency(agency.id).subscribe(data => {
          this.showToast({severity: 'success', detail: 'Agency has been DELETED.', summary: ''});
          this.loadAgencyList();
        });
      },
      reject: () => {
        this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
      }
    });
  }

  saveAgency(agency: AgencyDto) {
    this.caseService.saveAgency(agency).subscribe(data => {
      this.showToast({severity: 'success', detail: 'Agency has been Saved.', summary: ''});
      this.loadAgencyList();
      this.displayState.workingDiv = false;
      this.displayState.editAgencyDiv = false;
      this.displayState.gridDiv = true;
    });
  }

  // determine if all the required fields have been filled in
  agencyNeedRequiredData() {
    if (this.myAgency === null ) {
      return true;
    }
    this.utilService.doAudit(this.myAgency, 'Missing Agency Data; see:');
    if ( (this.myAgency.name.length < 1) || (this.myAgency.phone.length < 1) ) {
      return true;
    }
    else {
      return false;
    }
  }

  cancelEntry() {
    this.displayState.workingDiv = false;
    this.displayState.editAgencyDiv = false;
    this.filterOptions.filterText = ''; // clear any filters...
    this.displayState.gridDiv = true;
    return;
  }

  showToast(msg: Message) {
    this.messageService.add(msg);
    }
    
  clear() {
    this.messageService.clear();
  }
}
